import React from "react"
import GameDescription from "./GameDescription"
import ChangeLog from "./ChangeLog"

//column for game description, community event and changelog
class InfoColumn extends React.Component{
    render(){
        const { data } = this.props
        return(
            <div className="infoColumn">
                <GameDescription data={data}/>
                <hr />
                <ChangeLog data={data}/>
                <hr />
            </div>
        )
    }
}

export default InfoColumn